export default __webpack_public_path__ + "static/media/Instagram.91084741.svg";